import MuiSnackbar from "@mui/material/Snackbar/index.js";
import { styled } from "@mui/material/styles";
import { typography } from "../../themes/typography/typography.js";
import { SnackbarVariant } from "./snackbar.types.js";
import "../../themes/typography/utils/defaultVariantMapping/defaultVariantMapping.js";
import "../../themes/typography/utils/typographyVariants/typographyVariants.js";
const Root = styled(MuiSnackbar)(
  ({ theme, variant }) => ({
    boxShadow: theme.shadows[8],
    borderRadius: "4px",
    maxWidth: "344px",
    ".MuiSnackbarContent-action": {
      marginRight: 0,
      ...variant === SnackbarVariant.Multiline && {
        width: "100%",
        paddingLeft: 0,
        display: "flex",
        justifyContent: "flex-end"
      }
    },
    "& > .MuiPaper-root": {
      padding: "14px 16px",
      background: theme.palette.grey[800],
      ...variant === SnackbarVariant.Compact && {
        display: "flex",
        flexWrap: "nowrap"
      }
    },
    ".MuiSnackbarContent-message": {
      ...typography["Lato Body 2"],
      padding: 0,
      color: theme.palette.grey[50]
    }
  })
);
const Actions = styled("nav")({
  display: "flex",
  alignItems: "center",
  justifyContent: "flex-end"
});
const Close = styled("div")({
  display: "flex",
  alignItems: "center",
  marginBottom: "2px",
  cursor: "pointer"
});
export {
  Actions,
  Close,
  Root
};
